import { defineComponent as s, createElementBlock as o, openBlock as l, createElementVNode as r } from "vue";
const n = ["height", "width", "fill"], m = /* @__PURE__ */ s({
  __name: "EyeIcon",
  props: {
    size: { default: 24 },
    color: { default: "currentColor" }
  },
  setup(i) {
    return (e, t) => (l(), o("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: e.size,
      viewBox: "0 -960 960 960",
      width: e.size,
      fill: e.color
    }, t[0] || (t[0] = [
      r("path", { d: "M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-134 0-244.5-72T61-462q-5-9-7.5-18.5T51-500q0-10 2.5-19.5T61-538q64-118 174.5-190T480-800q134 0 244.5 72T899-538q5 9 7.5 18.5T909-500q0 10-2.5 19.5T899-462q-64 118-174.5 190T480-200Z" }, null, -1)
    ]), 8, n));
  }
}), h = ["height", "width", "fill"], v = {
  key: 0,
  d: "M120-120v-200h80v120h120v80H120Zm520 0v-80h120v-120h80v200H640ZM120-640v-200h200v80H200v120h-80Zm640 0v-120H640v-80h200v200h-80Z"
}, a = {
  key: 1,
  d: "M240-120v-120H120v-80h200v200h-80Zm400 0v-200h200v80H720v120h-80ZM120-640v-80h120v-120h80v200H120Zm520 0v-200h80v120h120v80H640Z"
}, _ = /* @__PURE__ */ s({
  __name: "FullScreenIcon",
  props: {
    variant: { default: "on" },
    size: { default: 24 },
    color: { default: "currentColor" }
  },
  setup(i) {
    return (e, t) => (l(), o("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: `${e.size}px`,
      viewBox: "0 -960 960 960",
      width: `${e.size}px`,
      fill: e.color
    }, [
      e.variant === "on" ? (l(), o("path", v)) : (l(), o("path", a))
    ], 8, h));
  }
}), d = ["height", "width", "fill"], g = /* @__PURE__ */ s({
  __name: "PauseIcon",
  props: {
    size: { default: 24 },
    color: { default: "currentColor" },
    variant: { default: "filled" }
  },
  setup(i) {
    return (e, t) => (l(), o("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: e.size,
      viewBox: "0 -960 960 960",
      width: e.size,
      fill: e.color
    }, t[0] || (t[0] = [
      r("path", { d: "M560-200v-560h160v560H560Zm-320 0v-560h160v560H240Z" }, null, -1)
    ]), 8, d));
  }
}), u = ["height", "width", "fill"], c = /* @__PURE__ */ s({
  __name: "PlayIcon",
  props: {
    size: { default: 24 },
    color: { default: "currentColor" },
    variant: { default: "filled" }
  },
  setup(i) {
    return (e, t) => (l(), o("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: e.size,
      viewBox: "0 -960 960 960",
      width: e.size,
      fill: e.color
    }, t[0] || (t[0] = [
      r("path", { d: "M320-200v-560l440 280-440 280Z" }, null, -1)
    ]), 8, u));
  }
}), p = ["height", "width", "fill"], q = /* @__PURE__ */ s({
  __name: "VolumeIcon",
  props: {
    size: { default: 24 },
    color: { default: "currentColor" },
    variant: { default: "filled" }
  },
  setup(i) {
    return (e, t) => (l(), o("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: e.size,
      viewBox: "0 -960 960 960",
      width: e.size,
      fill: e.color
    }, t[0] || (t[0] = [
      r("path", { d: "M560-131v-82q90-26 145-100t55-168q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 127-78 224.5T560-131ZM120-360v-240h160l200-200v640L280-360H120Zm440 40v-322q47 22 73.5 66t26.5 96q0 51-26.5 94.5T560-320Z" }, null, -1)
    ]), 8, p));
  }
}), w = ["height", "width", "fill"], Z = /* @__PURE__ */ s({
  __name: "VolumeMuteIcon",
  props: {
    size: { default: 24 },
    color: { default: "currentColor" },
    variant: { default: "filled" }
  },
  setup(i) {
    return (e, t) => (l(), o("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: e.size,
      viewBox: "0 -960 960 960",
      width: e.size,
      fill: e.color
    }, t[0] || (t[0] = [
      r("path", { d: "m616-320-56-56 104-104-104-104 56-56 104 104 104-104 56 56-104 104 104 104-56 56-104-104-104 104Zm-496-40v-240h160l200-200v640L280-360H120Zm280-246-86 86H200v80h114l86 86v-252ZM300-480Z" }, null, -1)
    ]), 8, w));
  }
});
export {
  m as _,
  _ as a,
  g as b,
  c,
  q as d,
  Z as e
};
